import React from 'react';
import styled from 'styled-components';

import {
  CenterTextWrapper,
  SVGParty,
  VerticalSpace,
} from '@brokerbay/design-components';
import { Text, Title } from 'components';
import { SUPPORT_EMAIL } from 'utils/constants';

const SVGPartyStyled = styled(SVGParty)`
  width: 100%;
`;

export const MlsAgentPlanView = () => (
    <VerticalSpace>
      <SVGPartyStyled />

      <Title textAlign="center" level={1} data-cy="title-setup">
        It looks like you are on the MLS Agent Plan
      </Title>
      <CenterTextWrapper>
        <Text>
          Please contact <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>{' '}
          with your details, and we will be happy to assist you.
        </Text>
      </CenterTextWrapper>
    </VerticalSpace>
  );
